import { render, staticRenderFns } from "./EcDataVideoModule.vue?vue&type=template&id=662782f9&scoped=true"
import script from "./EcDataVideoModule.vue?vue&type=script&lang=js"
export * from "./EcDataVideoModule.vue?vue&type=script&lang=js"
import style0 from "./EcDataVideoModule.vue?vue&type=style&index=0&id=662782f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662782f9",
  null
  
)

export default component.exports